import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const OrganizationBasicInfoComponent = ({ onInnerFormChange, organization, currencyCodeType }: any) => (
          <>
 <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'OrganizationInfo.Name',
                  organization?.OrganizationInfo
                )
              }}
              type="text"
              value={organization?.OrganizationInfo?.Name}
          />
    <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'OrganizationInfo.Email',
                  organization?.OrganizationInfo
                )
              }}
              type="text"
              value={organization?.OrganizationInfo?.Email}
          />
     <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'OrganizationInfo.PhoneNumber',
                  organization?.OrganizationInfo
                )
              }}
              type="text"
              value={organization?.OrganizationInfo?.PhoneNumber}
          />
    <InputContainer
            isDisabled={organization?.OrganizationInfo?.Id}
            label="Currency Code"
            labelField="Text"
            list={currencyCodeType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'OrganizationInfo.CurrencyCode',
                organization?.OrganizationInfo
              );
            }}
            optionName='Choose CurrencyCode'
            type="select"
            value={organization?.OrganizationInfo?.CurrencyCode}
            valueField="Text"
        />
          <InputContainer

              label="CSG Access Enabled For Portal"
              name="IsCSGAccessEnabledForPortal"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'OrganizationInfo.IsCSGAccessEnabledForPortal',
                  organization?.OrganizationInfo
                )
              }}
              type="checkbox"
              value={organization?.OrganizationInfo?.IsCSGAccessEnabledForPortal}
          />
      <InputContainer

              label="CSG Access Enabled For Service"
              name="IsCSGAccessEnabledForService"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'OrganizationInfo.IsCSGAccessEnabledForService',
                  organization?.OrganizationInfo
                )
              }}
              type="checkbox"
              value={organization?.OrganizationInfo?.IsCSGAccessEnabledForService}
          />
    </div>
  }
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
</>
)
export default OrganizationBasicInfoComponent;
